import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { SocialMediaCoreDomainNameStringAssets } from "../../../../../assets/stringAssets";

/**
 * @function referenceIsForAPinterestPost Returns whether the socialMediaPostRawReference is a Pinterest address
 * @param url
 */
export const referenceIsForAPinterestPost: (socialMediaPostRawReference: string) => boolean = (socialMediaPostRawReference: string) => {
  // return value (defaulted to 'false') indicating whether the socialMediaPostRawReference matches a known regular expression
  let foundMatchForRawReference: boolean = false;

  // as a quick check, determine whether this social media's core domain name is found withing the raw reference
  if (socialMediaPostRawReference.toLowerCase().search(SocialMediaCoreDomainNameStringAssets.Pinterest.toLowerCase()) !== -1) {

    // test for each type of raw reference for this social media type until a match is found or the list of social media types has been exhausted
    if (!foundMatchForRawReference) {
      foundMatchForRawReference = RegularExpressions.PinterestPostEmbedUrl.test(socialMediaPostRawReference);
    }

    if (!foundMatchForRawReference) {
      foundMatchForRawReference = RegularExpressions.PinterestPostIFrameWithFullSpecs.test(socialMediaPostRawReference);
    }
  }

  // return the result of testing the given socialMediaPostRawReference against the regex pattern(s)
  return foundMatchForRawReference;
}
